import React from 'react';

import { Skeleton } from '@repo/ui/components/ui/skeleton';

export const ChartsSectionSkeleton: React.FC = () => {
  return (
    <div className="flex w-full justify-center gap-5.25 px-3">
      <Skeleton className="size-19.5 shrink-0 rounded-full bg-[#2D3748] p-2">
        <div className="size-full rounded-full bg-background" />
      </Skeleton>
      <Skeleton className="size-19.5 shrink-0 rounded-full bg-[#2D3748] p-2">
        <div className="size-full rounded-full bg-background" />
      </Skeleton>
      <Skeleton className="size-19.5 shrink-0 rounded-full bg-[#2D3748] p-2">
        <div className="size-full rounded-full bg-background" />
      </Skeleton>
    </div>
  );
};
